import serviceAxios from "../request.js";

// VIP 套餐列表
export const getVipPlanList = (params) =>
  serviceAxios({
    url: "/api/vip/viporder/list",
    method: "get",
    params,
  });

// 创建 VIP 订单（返回扫码支付二维码）
export const createVipOrder = (data) =>
  serviceAxios({
    url: "/api/vip/order/pc/create",
    method: "post",
    data,
  });

// 检查 VIP 订单支付状态
export const checkVipPaymentStatus = (params) =>
  serviceAxios({
    url: "/api/vip/order/pc/status",
    method: "get",
    params,
  });
